import React, { useContext, useEffect, useState } from 'react';
import { AppContext } from '../../../../providers/appProvider';

import cl from "./Edit.module.css"
import Modal from '../../../UI/Modal/Modal'
import Pen from "../../../../assets/Icon/Pen";
import Select from "react-select";
import { selectStyle } from './selectStyle';
import { useBooking } from "../../../../hooks/useBooking";
import { validatePhoneNumber } from '../../../../utils/phone';
import ClientViewForm from '../ClientForm/ClientViewForm';

const QuotationEditModal = ({ QuotationService, defaultQuotation }) => {

    const initEditPrice = (Quotation) => {
        return {
            id: Quotation.id,
            quotation_id: Quotation.quotation_id,
            seller_id: Quotation.seller_id,
            status_id: Quotation.status_id,
            user_id: parseInt(Quotation.user_id),
            user: Quotation.user,

            sender_country_id: Quotation.sender_country_id,
            sender_city_id: Quotation.sender_city_id,
            reciever_country_id: Quotation.reciever_country_id,
            reciever_city_id: Quotation.reciever_city_id,
            type_id: Quotation.type_id, // Select transportation id
            created_at: Quotation.created_at || '',
            updated_at: Quotation.updated_at || '',

            marine_subtype_id: Quotation.marine_subtype_id,
            icoterm_id: Quotation.icoterm_id,
            land_subtype_id: Quotation.land_subtype_id,
            railway_subtype_id: Quotation.railway_subtype_id,
            marine_line_id: 0,
            period_start_at: Quotation.period_start_at || '',
            period_end_at: Quotation.period_end_at || '',
            issued_price: Quotation.issued_price || 0,
        }
    }

    const initialTypeOptions = [
        { value: 0, label: ' ' },
        { value: 1, label: 'საზღვაო' },
        { value: 2, label: 'სახმელეთო' },
        { value: 3, label: 'სარკინიგზო' },
        { value: 4, label: 'საჰაერო' },
      ];

    const marineSubtype = [
        { value: 0, label: 'FCL' },
        { value: 1, label: 'LCL' },
        { value: 2, label: 'Oversized' },
    ];
    
    const landSubtype = [
        { value: 0, label: 'FTL' },
        { value: 1, label: 'LTL' },
        { value: 2, label: 'FCL' },
        { value: 3, label: 'Oversized' },
    ];

    const railwaySubtype = [
        { value: 0, label: 'FCL' },
        { value: 1, label: 'LCL' },
        { value: 2, label: 'Wagon' },
        { value: 3, label: 'Cistern' },
        { value: 4, label: 'Oversized' },
    ];

    const incotermTypes = [
        { value: 0, label: 'FOB' },
        { value: 1, label: 'FCA' },
        { value: 2, label: 'ExW' },
        { value: 3, label: 'DAP' },
        { value: 4, label: 'CIF' },
    ];

    const statusTypes = [
        { value: 0, label: ' ' },
        { value: 1, label: 'წაგებული' },
        { value: 2, label: 'მიმდინარე' },
        { value: 3, label: 'მოგებული' },
      ];


    const [isModalOpen, setIsModalOpen] = useState(false);
    const [isConfirmationOpen, setIsConfirmationOpen] = useState(false);
    const [tmpStatus, setTmpStatus] = useState(0);
    const prevStatus = defaultQuotation.status_id;
    const { BookingService } = useBooking(50, true);
    const { appState, app } = useContext(AppContext);
    const [newQuotation, setNewQuotation] = useState(initEditPrice(defaultQuotation))
    const [typeOptions, setTypeOptions] = useState(initialTypeOptions);
    const marines = appState.marines.map((marine) => ({ value: marine.id, label: marine.name }));
    const [validates, setValidates] = useState({})

    useEffect(() => {
        const q = initEditPrice(defaultQuotation)
        setNewQuotation(q)
    }, [defaultQuotation]);

    const handleTypeIdChange = (selectedOption) => {
        setNewQuotation(prevPrice => ({
            ...prevPrice,
            type_id: selectedOption ? selectedOption.value : 0
        }));
    };

    const handleMarineSubtypeChange = (selectedOption) => {
        setNewQuotation(prevPrice => ({
            ...prevPrice,
            marine_subtype_id: selectedOption ? selectedOption.value : 0
        }));
    };

    const handleIncotermChange = (selectedOption) => {
       setNewQuotation(prevPrice => ({
            ...prevPrice,
            icoterm_id: selectedOption ? selectedOption.value : 0
        }));
    };
    const handleLandSubtypeChange = (selectedOption) => {
        setNewQuotation(prevPrice => ({
            ...prevPrice,
            land_subtype_id: selectedOption ? selectedOption.value : 0
        }));
    };

    const handleRailwaySubtypeChange = (selectedOption) => {
        setNewQuotation(prevPrice => ({
            ...prevPrice,
            railway_subtype_id: selectedOption ? selectedOption.value : 0
        }));
    };

    const openAdd = () => {
        setNewQuotation(initEditPrice(defaultQuotation))
        setIsModalOpen(true)
    }

    const openStatusChangeConfirmation = (selectedOption) => {
        setTmpStatus(selectedOption.value)
        setIsConfirmationOpen(true)
    }

    const closeStatusChangeConfirmation = () => {
        setIsConfirmationOpen(false)
    }

    const confirmStatusChange = async () => {
        setNewQuotation(prevPrice => ({
            ...prevPrice,
            status_id: tmpStatus
        }));
        setIsConfirmationOpen(false)
    }

    const saveHandle = async () => {
        const isValidate = validateQuotation(newQuotation)

        if (isValidate === true) {

            if(prevStatus != tmpStatus && tmpStatus === 3) {
                const bookingData = {
                    id: 0,
                    Booking_id:"0",
                    seller_id: newQuotation.seller_id,
                    status_id: 4,
                    user_id: newQuotation.user_id,
                    user: newQuotation.user,

                    sender_country_id: newQuotation.sender_country_id,
                    reciever_country_id: newQuotation.reciever_country_id,
                    type_id: newQuotation.type_id,
                    created_at: newQuotation.created_at,
                    updated_at: newQuotation.updated_at,
                    message: '',
                    description: '',
                    icoterm_id: newQuotation.icoterm_id,
                    land_subtype_id: newQuotation.land_subtype_id,
                    railway_subtype_id: newQuotation.railway_subtype_id,
                    marine_line_id: 0,
                    period_start_at: '',
                    period_end_at: '',
                    quotation_id: newQuotation.id,

                    issued_price: newQuotation.issued_price
                }

                console.log(bookingData)
        
                await BookingService.add(bookingData);
            }

            newQuotation.created_at = new Date().toLocaleString()
            QuotationService.update(newQuotation)
            setIsModalOpen(false)
        } else {
            console.log("Not valid or error")
            // setIsFirstValidated(true)
        }
    };

    const validateQuotation = (Quotation) => {
        const messages = {};

        if (Quotation.sender_country_id < 1) {
            messages.sender_country_id = { message: 'სავალდებულოა', isValid: false };
        }

        if (Quotation.reciever_country_id < 1) {
            messages.reciever_country_id = { message: 'სავალდებულოა', isValid: false };
        }

        if (Quotation.status_id === 0) {
            messages.status_id = { message: 'სავალდებულოა', isValid: false };
        }

        if (Quotation.type_id === 0) {
            messages.type_id = { message: 'სავალდებულოა', isValid: false };
        }

        console.log(Quotation)

        if (Quotation.type_id === 1) { // Marine
            if (!Quotation.marine_subtype_id || Quotation.marine_subtype_id < 1) {
                messages.marine_subtype_id = { message: 'სავალდებულოა', isValid: false };
            }
        } else if (Quotation.type_id === 2) { // Land
            if (!Quotation.land_subtype_id || Quotation.land_subtype_id < 1) {
                messages.land_subtype_id = { message: 'სავალდებულოა', isValid: false };
            }
        } else if (Quotation.type_id === 3) { // Railway
            if (!Quotation.railway_subtype_id || Quotation.railway_subtype_id < 1) {
                messages.railway_subtype_id = { message: 'სავალდებულოა', isValid: false };
            }
        }

        if (Quotation.icoterm_id === 0) {
            messages.icoterm_id = { message: 'სავალდებულოა', isValid: false };
        }


        if (Quotation.client_id === 0) {

            if (!Quotation.client.firstname || Quotation.client.firstname.length < 2) {
                messages.firstname = { message: 'მიუთითეთ სახელი', isValid: false };
            }


            if (!Quotation.client.lastname || Quotation.client.lastname.length < 2) {
                messages.lastname = { message: 'მიუთითეთ გვარი', isValid: false };
            }


            const emailRegex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/;

            if (!Quotation.client.email || Quotation.client.email.length < 2 || !emailRegex.test(Quotation.client.email)) {
                messages.email = { message: 'ელ-ფოსტა არასწორია', isValid: false };
            }
    
            if (!Quotation.client.mobile || !validatePhoneNumber(Quotation.client.mobile)) {                
                messages.mobile = { message: 'ნომერი არასწორია', isValid: false };
            }  
        } 

        const isValid = Object.keys(messages).length === 0;
        setValidates(messages)
        return isValid;
    };


    return(
        <div>
            <span className={cl.editBtn} onClick={() => openAdd()} >
                <Pen /> განახლება
            </span>

            <Modal size="small" isOpen={isModalOpen} onClose={() => setIsModalOpen(false)}>
                <div className={cl.modalHead} >
                    <h3><span className={cl.iconHead} > <Pen /></span> განახლება</h3>
                </div>

                <ClientViewForm clientData={newQuotation.user}></ClientViewForm>

                <fieldset className={cl.formField} style={{marginTop: '15px'}}>
                    <legend>ჩატვირთვის ქვეყანა</legend>
                    <Select
                        options={appState.countries}
                        value={appState.countries.find(country => country.id === newQuotation.sender_country_id) || null}
                        onChange={(selectedOption) => {
                            setNewQuotation(prevState => ({
                            ...prevState,
                            sender_country_id: selectedOption ? selectedOption.id : 0,
                            }));
                        }}
                        placeholder="ქვეყანა"
                        styles={selectStyle}
                        getOptionLabel={(option) => option.name}
                        getOptionValue={(option) => option.id}  
                    />

                </fieldset>

                <fieldset className={cl.formField}>
                    <legend>მიმღების ქვეყანა</legend>
                    <Select
                        options={appState.countries}
                        value={appState.countries.find(country => country.id === newQuotation.reciever_country_id) || null}
                        onChange={(selectedOption) => {
                            setNewQuotation(prevState => ({
                            ...prevState,
                            reciever_country_id: selectedOption ? selectedOption.id : 0,
                            }));
                        }}
                        placeholder="ქვეყანა"
                        styles={selectStyle}
                        getOptionLabel={(option) => option.name}
                        getOptionValue={(option) => option.id}  
                    />
                </fieldset>

                <fieldset style={{ display: "flex", gap: '10px', flexDirection: 'column' }} className={cl.formField}>                        
                        <div style={{ display: "flex", gap: '10px' }}>
                            <div style={{ width: "50%" }}>
                            <legend>გაცემული ფასი</legend>
                                <input
                                    type="number"
                                    className={`${cl.input} ${validates?.issued_price ? cl.error : 0}`}
                                    value={newQuotation.issued_price}
                                    onChange={(e) => {
                                        setNewQuotation(prevState => ({
                                            ...prevState,
                                            issued_price: parseInt(e.target.value)
                                        }));
                                    }}
                                    min={0}
                                    defaultValue={0}
                                    placeholder="გაცემული ფასი"
                                />
                            </div>
                        </div>
                </fieldset>

                <fieldset style={{ display: "flex", gap: '10px' }}  className={cl.formField}>
                    <legend>სტატუსი</legend>

                    <div style={{ width: "50%" }}>
                        <Select
                            styles={selectStyle}
                            options={statusTypes}
                            value={statusTypes.find(option => option.value === newQuotation.status_id)}
                            onChange={openStatusChangeConfirmation}
                            placeholder="ტიპი"
                        />
                    </div>
                    <div style={{ width: "50%" }}>
                    </div>
                </fieldset>


                <fieldset style={{ display: "flex", gap: '10px' }}  className={cl.formField}>
                    <legend>გადაზიდვის ტიპი</legend>

                    <div style={{ width: "50%" }}>
                        <Select
                            styles={selectStyle}
                            options={typeOptions}
                            value={typeOptions.find(option => option.value === newQuotation.type_id)}
                            onChange={handleTypeIdChange}
                            placeholder="ტიპი"
                        />
                    </div>
                    <div style={{ width: "50%" }}>
                    </div>
                </fieldset>

                {newQuotation.type_id === 1 ? (
                    <fieldset style={{ display: "flex", gap: '10px' }}  className={cl.formField}>

                        <div style={{ width: "50%" }}>
                            <legend>გადაზიდვის ქვე-ტიპი</legend>
                            <Select
                                styles={selectStyle}
                                options={marineSubtype}
                                value={marineSubtype.find(option => option.value === newQuotation.marine_subtype_id)}
                                onChange={handleMarineSubtypeChange}
                                placeholder="ტიპი"
                            />
                        </div>
                        <div style={{ width: "50%", position: "relative" }}>
                            <legend>Incoterms</legend>
                            <Select
                                styles={selectStyle}
                                options={incotermTypes}
                                value={incotermTypes.find(option => option.value === newQuotation.icoterm_id)}
                                onChange={handleIncotermChange}
                                placeholder="Incoterms"
                            />
                        </div>
                    </fieldset>
                ) : newQuotation.type_id == 2 ? (
                    <fieldset style={{ display: "flex", gap: '10px' }}  className={cl.formField}>

                        <div style={{ width: "50%" }}>
                            <legend>გადაზიდვის ქვე-ტიპი</legend>
                            <Select
                                styles={selectStyle}
                                options={landSubtype}
                                value={landSubtype.find(option => option.value === newQuotation.land_subtype_id)}
                                onChange={handleLandSubtypeChange}
                                placeholder="ტიპი"
                            />
                        </div>
                        <div style={{ width: "50%", position: "relative" }}>
                            <legend>Incoterms</legend>
                            <Select
                                styles={selectStyle}
                                options={incotermTypes}
                                value={incotermTypes.find(option => option.value === newQuotation.icoterm_id)}
                                onChange={handleIncotermChange}
                                placeholder="Incoterms"
                            />
                        </div>
                    </fieldset>
                ) : newQuotation.type_id == 3 ? (
                    <fieldset style={{ display: "flex", gap: '10px' }}  className={cl.formField}>
                        <div style={{ width: "50%" }}>
                            <legend>გადაზიდვის ქვე-ტიპი</legend>
                            <Select
                                styles={selectStyle}
                                options={railwaySubtype}
                                value={railwaySubtype.find(option => option.value === newQuotation.railway_subtype_id)}
                                onChange={handleRailwaySubtypeChange}
                                placeholder="ტიპი"
                            />
                        </div>
                        <div style={{ width: "50%", position: "relative" }}>
                            <legend>Incoterms</legend>
                            <Select
                                styles={selectStyle}
                                options={incotermTypes}
                                value={incotermTypes.find(option => option.value === newQuotation.icoterm_id)}
                                onChange={handleIncotermChange}
                                placeholder="Incoterms"
                            />
                        </div>
                    </fieldset>
                )
                : (
                    <fieldset style={{ display: "flex", gap: '10px' }}  className={cl.formField}>
                        <div style={{ width: "50%", position: "relative" }}>
                            <legend>Incoterms</legend>
                            <Select
                                styles={selectStyle}
                                options={incotermTypes}
                                value={incotermTypes.find(option => option.value === newQuotation.icoterm_id)}
                                onChange={handleIncotermChange}
                                placeholder="Incoterms"
                            />
                        </div>
                        <div style={{ width: "50%" }}></div>
                    </fieldset>
                )}

                <span onClick={saveHandle} className={cl.btnPrimary}>შენახვა</span>

            </Modal>

            <Modal key={defaultQuotation.id} size="medium" isOpen={isConfirmationOpen} onClose={() => closeStatusChangeConfirmation()}>

                <div className={ cl.modalHead }><h3>დადასტურება</h3></div> 
                <div className={ cl.message } >გსურთ სტატუსის შეცვლა?</div>
                <div className={ cl.buttons }>
                    <button className={ cl.btnPrimary } onClick={confirmStatusChange}>დიახ მსურს!</button> 
                </div> 
            </Modal>

        </div>
    )
}

export default QuotationEditModal;